module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Carolinas PGA-b7665ec43d9a80f7a282a980c9c1345a.png";